function handleTables() {
    const tables = document.querySelectorAll('table');
  
    if (!tables.length > 0) return;
  
    tables.forEach((table) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('table-wrapper');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }


function moveLocalTask() {
  const placeholder = document.querySelector("#client-reports-tabs-placeholder");
  const localTask = document.querySelector(".local-task-wrapper");

  if (!placeholder || !localTask) return;
    placeholder.appendChild(localTask);
    localTask.classList.add('ready');

}

function closeAccordionOptions() {
  const items = document.querySelectorAll(".webform-results-export details");

  if (!items.length > 0) return;

  items.forEach((item) => {
    item.removeAttribute("open");
    const btn = item.querySelector("[role='button']");

    if (btn) {
      btn.setAttribute("aria-expanded", false);
      btn.setAttribute("aria-pressed", false);
    }
  });
}

window.addEventListener('load', () => {
  handleTables();
  moveLocalTask();
  closeAccordionOptions()
})